// extracted by mini-css-extract-plugin
export var card = "Column2CardGroup-module--card--1a7b9";
export var cardContent = "Column2CardGroup-module--cardContent--4b711";
export var cardGroup = "Column2CardGroup-module--cardGroup--9306d";
export var cardHeader = "Column2CardGroup-module--cardHeader--e1f2f";
export var cardMeta = "Column2CardGroup-module--cardMeta--9b267";
export var description = "Column2CardGroup-module--description--4f1c5";
export var image = "Column2CardGroup-module--image--88e2e";
export var primaryLayout = "Column2CardGroup-module--primaryLayout--4a51c";
export var secondaryLayout = "Column2CardGroup-module--secondaryLayout--80bd6";